/**
 * DownloadModalCtrl
 * Functionality to initiate a download.
 *
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */
angular.module('satv.media')
    .controller('DownloadQueueCtrl',
        ['$scope', '$rootScope', 'ZippedDownload', 'DownloadQueueModal', 'Auth', '$interval', '$window', 'growl', '$timeout', function ($scope, $rootScope, ZippedDownload, DownloadQueueModal, Auth, $interval, $window, growl, $timeout) {

            var interval = 8000,
                isPolling = false,
                intervalHandle;

            $scope.hasDownloadsInProgress = false;
            var refresh;
            var doRefresh = function () {
                refresh();
            };
            refresh = function () {
                ZippedDownload.getQueue(function (downloads) {
                    $scope.hasDownloadsInProgress = downloads.length > 0;

                    //@todo this is to inform other controllers of refreshed data
                    //this functionality should be moved into a service used
                    //by both controllers. However for now this works.
                    $rootScope.$emit('MEDIA_DOWNLOAD_QUEUE_REFRESH', downloads);

                    for (var i = 0; i < downloads.length; i++) {
                        var download = downloads[i];

                        if (download._links && download._links.download) {
                            $rootScope.$emit('MEDIA_DOWNLOAD_READY', download);
                            break;
                        }
                        if (download.status_str === 'FAILED' || download.status_str === 'POISON') {
                            growl.error(download.error_msg);
                            download.$unsubscribe(doRefresh);
                            break;
                        }
                    }

                    //we can stop polling if we have an empty queue
                    if (!$scope.hasDownloadsInProgress) {
                        stopPolling();
                    }

                }, function (resp) {
                    stopPolling();
                });
            };

            var poll = function () {

                //check signpost so that we don't start polling twice
                if (isPolling) {
                    return false;
                }

                //set signpost
                isPolling = true;

                //do one initial one
                refresh();

                //do one every now and then
                intervalHandle = $interval(function () {
                    refresh();
                }, interval);
            };

            var stopPolling = function () {
                $interval.cancel(intervalHandle);

                //set signpost
                isPolling = false;
            };

            //check if we're already logged in, if so poll
            //we do this with a delay so as to not interfere with pageload
            $timeout(function () {
                Auth.getAccess().then(function (resp) {
                    if (resp.isAuthenticated) {
                        poll();
                    }
                });
            }, 3000);

            //ping once on login
            Auth.onLogin(function () {
                poll();
            });

            //initiate a poll when a download is enqueued
            $rootScope.$on('MEDIA_DOWNLOAD_ENQUEUED', function (e) {
                //either start polling or initate a refresh
                if (poll() === false) {
                    refresh();
                }
            });

            $scope.openModal = function () {
                DownloadQueueModal.open();
            };
        }]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/controllers/DownloadQueueCtrl.js